import { useEffect } from 'react';
import { ConfirmModal } from 'components/ui/modals';
import { IUserWithProvider } from 'model/user';
import useUserList from 'components/hooks/useUserList';
import { useSafeState } from 'ahooks';
import { Alert } from 'antd';

interface IReactivateUserModalProps {
  openModal: boolean;
  selectedUser: IUserWithProvider;
  onClose: () => void;
  onUpdate: () => void;
}

export const ReactivateUserModal = ({ openModal, selectedUser, onUpdate, onClose }: IReactivateUserModalProps) => {
  const [isLoading, setIsLoading] = useSafeState(false);
  const [validationError, setValidationError] = useSafeState('');
  const { reactivateUser } = useUserList(true);

  useEffect(() => {
    const checkIfUserCanBeEnabled = async () => {
      setIsLoading(true);
      const [, error] = await reactivateUser(selectedUser.username, true);
      if (!error) {
        setValidationError('');
      } else {
        setValidationError(error.message);
      }
      setIsLoading(false);
    };
    checkIfUserCanBeEnabled();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser.username, setValidationError]);

  return (
    <ConfirmModal
      title="Reactivate"
      onCancel={onClose}
      isModalVisible={openModal}
      onConfirm={onUpdate}
      submitButtonProps={{ disabled: !!validationError, loading: isLoading }}
    >
      {!!validationError && <Alert message={validationError} type="error" style={{ marginBottom: '1rem' }} showIcon />}
      <>
        Are you sure you want to reactivate <strong>{selectedUser.name}</strong>? This user will regain access to
        MicroCred Seeker Provider Portal with the role they held at the time of deactivation.
      </>
    </ConfirmModal>
  );
};
